<template>
    <div class="input--number">
        <input type="number" v-model.number="number" :min="min" :max="max">
        <div class="incrementButton" @click="incrementValue"></div>
        <div class="decrementButton" @click="decrementValue"></div>
    </div> 
</template>
<script type="text/javascript">
    export default {
        props:{
            value:{
                type:Number,
                default:0
            },
            min:{
                type:Number,
                default:Number.MIN_SAFE_INTEGER,
            },
            max:{
                type:Number,
                default:Number.MAX_VALUE,
            },
        },
        data(){
            return {
                number:0
            }
        },
        methods:{
            incrementValue(){
                this.number = Math.min(this.max, this.number + 1);
            },
            decrementValue(){
                this.number = Math.max(this.min, this.number - 1);
            }
        },
        watch:{
            value:{
                immediate:true,
                handler(value){
                    this.number = value;
                }
            },
            number(){
                this.$emit("input",this.number);
            }
        }
    }
</script>
<style lang="scss">
    .input--number[type=number]::-webkit-inner-spin-button, 
    .input--number[type=number]::-webkit-outer-spin-button { 
      -webkit-appearance: none; 
      margin: 0; 
    }
    .input--number{
        font-size: 1rem;
        width: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        padding: 15px;
        outline: none;
        font-size: 1em;
        box-sizing: border-box;
        max-width: 100%;
        &:focus:not(:focus-visible){
            outline: none;
        }
        &.error{
            border: solid 1px #ff0000;
        }
    }
    .input--number input[type=number]{
        width: 70%;
        text-align: center;
    }
    .input--number .incrementButton,
    .input--number .decrementButton{
        width: 0;
        height: 0;
        box-sizing: border-box;
        border-top: solid 6px transparent;
        border-bottom: solid 6px transparent;
        position: absolute;
        top: calc(50% - 6px);
        cursor: pointer;
    }
    .input--number .incrementButton{
        border-left: solid 8px #333;
        right: 0;
    }
    .input--number .decrementButton{
        border-right: solid 8px #333;
        left: 0;
    }
</style>